import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const AirplaneIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M18.6 2c1-.2 2-.3 2.8.1l.5.5c.4.8.3 1.8 0 2.8a7 7 0 0 1-1.7 2.8l-3.1 3.1 1.7 7.7-1 .2 1-.2a2.1 2.1 0 0 1-1.1 2.3l-.5.2a2 2 0 0 1-2.5-.6l-3-4.5-1.7 1.1V20c0 .3-.1.5-.3.7l-1 1a1 1 0 0 1-1.5-.1l-2-2.9-2.8-1.9a1 1 0 0 1-.1-1.5l1-1c.2-.2.4-.3.7-.3h2.5l1.1-1.7-4.5-3a2 2 0 0 1-.6-2.5v-.1l.3-.5a2 2 0 0 1 2.2-1L12.7 7l3-3.1a7 7 0 0 1 3-1.8Zm-1.8 17.4L15 11.2c0-.3 0-.7.3-1l3.5-3.4a5 5 0 0 0 1.2-2c.2-.4.2-.8.2-1-.2 0-.6 0-1 .2a5 5 0 0 0-2 1.2l-3.5 3.5a1 1 0 0 1-1 .3l-8-1.8-.3.4v.1l5.3 3.5a1 1 0 0 1 .2 1.4l-2 3a1 1 0 0 1-.8.4H4.8l1.8 1.2.2.2L8 19.2V17c0-.3.2-.6.4-.8l3-2a1 1 0 0 1 1.4.2l3.5 5.3h.1l.4-.2v-.1Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default AirplaneIcon;
